<section class="bn-actions-section" aria-labelledby="care-plan-actions-heading">
  <header
    class="bn-actions-section__header flex items-center justify-between gap-3"
  >
    <h3 id="care-plan-actions-heading" class="bn-actions-section__title m-0">
      <i class="pi pi-check-square" aria-hidden="true"></i>
      Actions <span>({{ store.count() }})</span>
    </h3>
    @if (!readonly()) {
      <button
        type="button"
        class="bn-actions-section__add"
        [disabled]="!store.canCreate()"
        [attr.title]="
          store.canCreate()
            ? null
            : 'All Action System Code catalogs are required before creating actions.'
        "
        (click)="openAdd()"
      >
        + Add
      </button>
    }
  </header>

  @if (store.loading()) {
    <div class="flex flex-col gap-3" role="status" aria-label="Loading actions">
      <p-skeleton height="6.25rem" borderRadius="0.75rem" />
      <p-skeleton height="6.25rem" borderRadius="0.75rem" />
    </div>
  } @else if (store.error(); as error) {
    <div class="bn-actions-section__message" role="alert">
      <p class="m-0">{{ error }}</p>
      <button type="button" (click)="store.retry()">Retry</button>
    </div>
  } @else {
    @if (!store.canCreate() && !readonly()) {
      <div class="bn-actions-section__dependency" role="status">
        <strong>New actions are temporarily unavailable.</strong>
        @if (store.catalogDependency()) {
          <span>{{ store.catalogDependency() }}</span>
        }
        @if (store.ownerDependency()) {
          <span>{{ store.ownerDependency() }}</span>
        }
      </div>
    }

    @if (store.actions().length === 0) {
      <div class="bn-actions-section__message">
        <p class="m-0">No actions yet.</p>
      </div>
    } @else {
      <bn-care-plan-card-list ariaLabel="Actions for this case">
        @for (action of store.actions(); track action.id) {
          <bn-action-card
            entryPoint="care_plan_case"
            [action]="action"
            [store]="store"
            [readonly]="readonly()"
          />
        }
      </bn-care-plan-card-list>
    }
  }
</section>
